export function getNumberOfDays() {
  let year = new Date().getFullYear();
  if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) return 366;
  return 365;
}

export function dateTimeString(date: Date): string {
  if (!date) {
    return null;
  }

  if (typeof date === 'string') date = new Date(Date.parse(date));

  var year = date.getFullYear().toString();
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  var hours = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  var seconds = date.getSeconds().toString().padStart(2, '0');

  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
}
